import RestClient from '../../../../api/axiosInterceptor';
import { doctorProfileActions } from '../../../actions/user/doctor/profile';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();
    dispatch({ type: actionType.SUCCESS, payload: response.data });
    toast.success(response.data.message, { position: 'top-center' });
    return { status: response.status, data: response.data };
  } catch (error) {
    const errorMessage =
			error.response && error.response.data && error.response.data.error
			  ? error.response.data.error
			  : error.message;

    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
    return { error: errorMessage };
  }
};

export const updateDoctorProfile = (formData) => {
  return createAsyncAction(doctorProfileActions.UPDATE_DOCTOR, () => {
    return RestClient.post('/auth1/profile/completion/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
  });
};

export const fetchDoctorProfile = () => async (dispatch) => {
  try {
    dispatch({ type: doctorProfileActions.FETCH_DOCTOR.REQUEST });

    const response = await RestClient.get('/auth1/profile/completion/', {
      withCredentials: true
    });
    // Add this log to see what comes from the API
    console.log('API response is_verified:', response.data?.is_verified);

    // Extract verification status from response
    const isVerified = response.data?.is_verified === true;

    // Save verification status in Redux and localStorage
    localStorage.setItem('pendingApproval', isVerified ? 'false' : 'true');

    // Add this log to see what's stored in localStorage
    console.log(
      'localStorage pendingApproval:',
      localStorage.getItem('pendingApproval')
    );

    dispatch({
      type: doctorProfileActions.FETCH_DOCTOR.SUCCESS,
      payload: response.data
    });
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    dispatch({
      type: doctorProfileActions.FETCH_DOCTOR.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage);
  }
};
